
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const LoadingAppDetail: React.FC = () => {
  const navigate = useNavigate();
  const [loadingTime, setLoadingTime] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setLoadingTime(prev => prev + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const getLoadingMessage = () => {
    if (loadingTime < 3) return 'Loading app details...';
    if (loadingTime < 8) return 'Fetching app information...';
    return 'This is taking longer than usual. Please wait...';
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="sticky top-0 bg-background/80 backdrop-blur-sm border-b border-border z-10">
        <div className="p-4">
          <div className="flex items-center mb-4">
            <Button
              variant="ghost"
              onClick={() => navigate('/')}
              className="flex items-center space-x-2"
            >
              <ArrowLeft className="w-4 h-4" />
              <span>Back</span>
            </Button>
          </div>
          
          {/* Loading App Info */}
          <div className="animate-pulse">
            <div className="flex items-center space-x-4 mb-4">
              <div className="w-16 h-16 bg-muted rounded-xl"></div>
              <div className="flex-1">
                <div className="h-6 bg-muted rounded w-3/4 mb-2"></div>
                <div className="h-4 bg-muted rounded w-1/2"></div>
              </div>
            </div>
            <div className="h-12 bg-muted rounded"></div>
          </div>
        </div>
      </div>

      {/* Loading Description */}
      <div className="p-4">
        <div className="animate-pulse">
          <div className="bg-muted rounded-lg h-96 flex items-center justify-center">
            <div className="text-center">
              <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
              <p className="text-muted-foreground">{getLoadingMessage()}</p>
              {loadingTime > 5 && (
                <p className="text-sm text-muted-foreground mt-2">
                  Elapsed time: {loadingTime}s
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingAppDetail;
